import { createSlice } from '@reduxjs/toolkit';

import { getAdminById, updateAdminById } from './actions';

const adminSlice = createSlice({
  name: 'currentAdmin',
  initialState: null,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getAdminById.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(updateAdminById.fulfilled, (state: any, action: any) => {
      return { ...state, ...action.payload };
    });
  },
});

export default adminSlice.reducer;
